<template>
  <section :id="galleryID" class="need-to-know card">
    <h3 class="title">{{ $t('product_purchase_notice') }}</h3>
    <collapsible-article
      class="text-article my-4"
      :expand-btn-text="$t('all_show_all')"
      :collapse-btn-text="$t('all_show_partially')"
      :show-collapse-btn="true"
      :line-num="10"
    >
      <content-data v-for="(data, idx) in purchaseNotice" :key="idx" v-bind="data"></content-data>
    </collapsible-article>
  </section>
</template>

<script setup lang="ts">
import CollapsibleArticle from '@/components/common/collapsible-article.vue'
import ContentData from '@/components/common/content-data.vue'

import type { UiProductInfo } from '@/types/product'

const galleryID = 'product-need-to-know'
const { lightboxInit } = useLightbox(galleryID)

const props = defineProps<{
  product: UiProductInfo
}>()

const purchaseNotice = computed(() =>
  (props.product?.purchase_notice || []).map(item => ({
    type: item.type,
    meta: item.meta,
    list: item.attr?.list || [],
    mediaWidth: item.attr?.width || 0,
    mediaHeight: item.attr?.height || 0,
  }))
)

onMounted(() => {
  lightboxInit()
})
</script>

<style lang="scss" scoped></style>
